import { React, useState } from 'react';
import style from './../adminSect.module.scss';
import { FormOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import { CustomButton, CustomPaginate, LoadingTable } from '../../utils/Utils';
import { SmallModal } from '../../utils/Modals';
import axios from './../../../config/apiConfig';
import moment from 'moment';

const Table = (props) => {
  const {
    showEditUser,
    setShowEditUser,
    toggleModal,
    showUserData,
    setShowUserData,
    setUserTriggerData,
    setShowStandsModal,
    showStandsModal,
    usersData,
    totalPages,
    getUsers,
    setPage,
    page,
    isLoading,
  } = props;
  const {
    usersTable,
    tablePadding,
    btnsTd,
    btnsContainers,
    tpo,
    pharmacist,
    admin,
    supplier,
    firstUserTd,
    loadingComp,
    usersTableContainer,
    accessDisabled,
  } = style;

  const [showConfirmDeleteUser, setShowConfirmDeleteUser] = useState(false);
  const [deletingUser, setDeletingUser] = useState({});
  const [smallModalMsg, setSmallModalMsg] = useState({bol: false, msg: ''});

  const modalTrigger = (u, dataState, set, state) => {
    dataState(u);
    toggleModal(set, state);
  };

  const deleteConfirmed = async () => {
    try {
      const { data } = await axios.delete(`/users/${deletingUser._id}`);
      toggleModal(setShowConfirmDeleteUser, showConfirmDeleteUser);
      getUsers();
      setSmallModalMsg({bol: true, msg: 'Usuario eliminado con exito'});
      console.log(data); // eslint-disable-line
    } catch (error) {
      console.log(error); // eslint-disable-line
    }
  };

  const getTpo = (user) => {
    const tpoClass = {
      pharmacy: pharmacist,
      admin: admin,
      supplier: supplier,
    };
    return tpoClass[user];
  };

  const translateTpo = {
    pharmacy: 'F',
    admin: 'A',
    supplier: 'P'
  };

  const displayTable = (user) => {

    if (user.role === 'pharmacy') {
      return (
        <>
          <td className={user.isAccessOpen ? '' : accessDisabled}>{user.fullName || user.email || user.pharmacy?.owner || user.pharmacy?.name || user.pharmacy?.email || user.accountNumber}</td>
          <td className={user.isAccessOpen ? '' : accessDisabled}>{user.pharmacy?.cellPhone || <i>{'Completar datos'}</i>}</td>
          <td className={user.isAccessOpen ? '' : accessDisabled}>{moment(user.regDate).format('DD-MM-YYYY HH:mm')}</td>
          <td className={user.isAccessOpen ? '' : accessDisabled}>{user.accountNumber}</td>
        </>
      );
    } else {
      return (
        <>
          <td className={user.isAccessOpen ? '' : accessDisabled}>{user.fullName || user.email|| user.accountNumber}</td>
          <td className={user.isAccessOpen ? '' : accessDisabled}>{user.phoneNumber || <i>{'Completar datos'}</i>}</td>
          <td className={user.isAccessOpen ? '' : accessDisabled}>{moment(user.regDate).format('DD-MM-YYYY HH:mm')}</td>
          <td className={user.isAccessOpen ? '' : accessDisabled}>{user.accountNumber || <i>{'Completar datos'}</i>}</td>
        </>
      );
    }
  };

  return (
    <div className={usersTableContainer}>
      <div className={tablePadding}>
        <table className={usersTable}>
          <thead>
            <tr>
              <th>
                <b>Tpo</b>
              </th>
              <th>
                <b>Nombre y apellido</b>
              </th>
              <th>
                <b>Teléfono</b>
              </th>
              <th>
                <b>Fecha ingreso</b>
              </th>
              <th>
                <b>Núm. de cuenta</b>
              </th>
              <th>
                <b></b>
              </th>
            </tr>
          </thead>
          <tbody>
            {usersData
              ? usersData.map((u, i) => {
                return (
                  <tr key={i}>
                    <td className={firstUserTd}>
                      <div className={`${tpo} ${getTpo(u.role)}`}>{translateTpo[u.role]}</div>
                    </td>
                    {displayTable(u)}
                    <td>
                      <div className={btnsTd}>
                        <div className={btnsContainers}>
                          <EyeOutlined
                            onClick={() =>
                              modalTrigger(
                                u,
                                setUserTriggerData,
                                setShowUserData,
                                showUserData,
                              )
                            }
                          />
                          <FormOutlined
                            onClick={() =>
                              modalTrigger(
                                u,
                                setUserTriggerData,
                                setShowEditUser,
                                showEditUser,
                              )
                            }
                          />
                          <DeleteOutlined
                            style={{color: '#F57255'}}
                            onClick={() =>
                              modalTrigger(
                                u,
                                setDeletingUser,
                                setShowConfirmDeleteUser,
                                showConfirmDeleteUser,
                              )
                            }
                          />
                        </div>
                        {u.role === 'supplier' ? (
                          <CustomButton
                            color="btnOrange"
                            size="sm"
                            content="ASIGNAR STAND"
                            onclick={() =>
                              modalTrigger(
                                u,
                                setUserTriggerData,
                                setShowStandsModal,
                                showStandsModal,
                              )
                            }
                          />
                        ) : (
                          <CustomButton
                            color="btnOrange"
                            size="sm"
                            content="ASIGNAR STAND"
                            disabled={true}
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })
              : 'aa'}
          </tbody>
        </table>
        {isLoading && 
          <div className={loadingComp}>
            <LoadingTable />
          </div>}
      </div>
      <CustomPaginate setPage={setPage} page={page} totalPages={totalPages} />

      <SmallModal
        title="¿Seguro que quiere eliminar el usuario?"
        toggle={toggleModal}
        state={showConfirmDeleteUser}
        set={setShowConfirmDeleteUser}
        howManyBtn="2"
        firstBtn={{
          color: 'btnOrange',
          content: 'Cerrar',
          onclick: () =>
            toggleModal(setShowConfirmDeleteUser, showConfirmDeleteUser),
        }}
        secondBtn={{
          color: 'btnOutline',
          content: 'Eliminar',
          onclick: deleteConfirmed,
        }}
      />

      <SmallModal
        title={smallModalMsg.msg}
        toggle={toggleModal}
        state={smallModalMsg.bol}
        set={smallModalMsg}
        secondBtn={{
          color: 'btnPrimary',
          content: 'Cerrar',
          onclick: () => {setSmallModalMsg({bol: false, msg:''});},
        }}
      />  
    </div>
  );
};

export default Table;
